module.exports = __webpack_public_path__ + "img/stockvault.276be98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/stockvault.jpg
// module id = NTfb
// module chunks = 0